module.exports = __webpack_public_path__ + "img/dama-cencet.9227c130.png";